/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './visibility_styles'
import Space from 'material/space/space';
import { InlineMessage, Radio } from '@insticator/insticator-ui/dist/material';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADS SECTION : VISIBILITY ~~~~~~~~~~ ========== */
const Visibility = injectSheet(styles)((props) => {

  const { visibility, onChange } = props

  return (
    <SectionGroupV2 
      title={'Visibility'} 
      description={'Determine which users will receive an ad'}
      indented  
      klass={`visibility ${props.classes.visibility}`} 
    >
      <Space direction={'column'}>
        <Radio 
          isList
          title={`All users`}
          checked={visibility === 'ALL_USERS'}
          handleChange={() => onChange('visibility', 'ALL_USERS')}
        />
        <Radio 
          isList
          title={`Only users who are not logged in`}
          checked={visibility === 'NON_SIGN_IN_USERS'}
          handleChange={() => onChange('visibility', 'NON_SIGN_IN_USERS')}
        />
        <Radio 
          isList
          title={`None`}
          checked={visibility === 'NONE'}
          handleChange={() => onChange('visibility', 'NONE')}
        />
        {visibility !== 'ALL_USERS' && (
        <InlineMessage 
          name={'headercode'}
          variant={'warning'} 
          icon={'exclamation-triangle'} 
          message={<span>
            <strong>Warning: </strong>
            This will negatively impact revenue!<br />Please ensure there is{' '}
            <acronym title="Software as a Service">SaaS</acronym>
            {' '}pricing in place for this site.
          </span>}
        />
        )}
      </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Visibility;